import { render, staticRenderFns } from "./ReportTableBalance.vue?vue&type=template&id=d389a252"
import script from "./ReportTableBalance.vue?vue&type=script&lang=ts"
export * from "./ReportTableBalance.vue?vue&type=script&lang=ts"
import style0 from "./ReportTableBalance.vue?vue&type=style&index=0&id=d389a252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports